// Corrige somente texto cujo contraste ficou baixo após renderizar o HTML do e-mail.
// Preserva as cores do remetente quando continuam legíveis.
const parseColor = value => {
  const channels = value?.match(/rgba?\(([^)]+)\)/)?.[1]?.match(/[\d.]+/g);
  if (!channels || channels.length < 3) return null;
  return [
    Number(channels[0]),
    Number(channels[1]),
    Number(channels[2]),
    channels[3] === undefined ? 1 : Number(channels[3]),
  ];
};

const backgroundAt = (element, root) => {
  const layers = [];
  for (let node = element; node; node = node.parentElement) {
    layers.unshift(node);
    if (node === root) break;
  }
  return layers.reduce(
    (base, node) => {
      const color = parseColor(getComputedStyle(node).backgroundColor);
      if (!color) return base;
      const alpha = color[3];
      return color
        .slice(0, 3)
        .map((channel, index) => channel * alpha + base[index] * (1 - alpha));
    },
    [255, 255, 255]
  );
};

const luminance = color => {
  const values = color.slice(0, 3).map(channel => {
    const linear = channel / 255;
    return linear <= 0.04045
      ? linear / 12.92
      : ((linear + 0.055) / 1.055) ** 2.4;
  });
  return values[0] * 0.2126 + values[1] * 0.7152 + values[2] * 0.0722;
};

const contrast = (first, second) => {
  const [lighter, darker] = [luminance(first), luminance(second)].sort(
    (a, b) => b - a
  );
  return (lighter + 0.05) / (darker + 0.05);
};

export const ensureEmailContrast = root => {
  if (!root) return;
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const elements = new Set();
  while (walker.nextNode()) {
    if (walker.currentNode.textContent.trim())
      elements.add(walker.currentNode.parentElement);
  }

  elements.forEach(element => {
    if (!element) return;
    const style = getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') return;
    const foreground = parseColor(style.color);
    if (!foreground) return;
    const background = backgroundAt(element, root);
    const visibleColor = foreground
      .slice(0, 3)
      .map(
        (channel, index) =>
          channel * foreground[3] + background[index] * (1 - foreground[3])
      );
    if (contrast(visibleColor, background) >= 4.5) return;
    const dark = [32, 33, 36];
    const replacement = contrast(dark, background) >= 4.5 ? '#202124' : '#fff';
    element.style.setProperty('color', replacement, 'important');
  });
};
